module.exports = __webpack_public_path__ + "img/Evening Primrose Oil.7903d395.png";